import React from "react";

export const CART_ICONS = {
  confirmWarning: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#FF424E" fill-opacity="0.1" />
      <path
        d="M31 20H21V36H35V24H31V20ZM19 18.9918C19 18.4441 19.4475 18 19.9985 18H32L36.9997 23L37 36.9925C37 37.5489 36.5551 38 36.0066 38H19.9934C19.4448 38 19 37.5447 19 37.0082V18.9918ZM27 31H29V33H27V31ZM27 23H29V29H27V23Z"
        fill="#FF424E"
      />
    </svg>
  ),
  confirmDelete: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#FF424E" fill-opacity="0.1" />
      <path
        d="M33 20H38V22H36V37C36 37.5523 35.5523 38 35 38H21C20.4477 38 20 37.5523 20 37V22H18V20H23V18H33V20ZM25 25V33H27V25H25ZM29 25V33H31V25H29Z"
        fill="#FF424E"
      />
    </svg>
  ),
  down: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99954 13.0941L15.0079 8.08578L13.8304 6.90662L9.99954 10.7399L6.16954 6.90662L4.99121 8.08495L9.99954 13.0941Z"
        fill="#0075FF"
      />
    </svg>
  ),
  up: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99948 6.90674L4.99115 11.9151L6.16865 13.0942L9.99948 9.2609L13.8295 13.0942L15.0078 11.9159L9.99948 6.90674Z"
        fill="#0075FF"
      />
    </svg>
  ),
  note: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4 20.5H5.60005C5.15822 20.5 4.80005 20.1418 4.80005 19.7V5.3C4.80005 4.85818 5.15822 4.5 5.60005 4.5H18.4C18.8419 4.5 19.2 4.85818 19.2 5.3V19.7C19.2 20.1418 18.8419 20.5 18.4 20.5ZM8.80005 8.5V10.1H15.2V8.5H8.80005ZM8.80005 11.7V13.3H15.2V11.7H8.80005ZM8.80005 14.9V16.5H12.8V14.9H8.80005Z"
        fill="#1162FF"
      />
    </svg>
  ),
  delivery: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.5C12.4812 12.5 12.8932 12.3238 13.2359 11.9713C13.5786 11.6188 13.75 11.195 13.75 10.7C13.75 10.205 13.5786 9.78125 13.2359 9.42875C12.8932 9.07625 12.4812 8.9 12 8.9C11.5187 8.9 11.1068 9.07625 10.7641 9.42875C10.4214 9.78125 10.25 10.205 10.25 10.7C10.25 11.195 10.4214 11.6188 10.7641 11.9713C11.1068 12.3238 11.5187 12.5 12 12.5ZM12 21.5C9.65208 19.445 7.89844 17.5363 6.73906 15.7738C5.57969 14.0113 5 12.38 5 10.88C5 8.63 5.70365 6.8375 7.11094 5.5025C8.51823 4.1675 10.1479 3.5 12 3.5C13.8521 3.5 15.4818 4.1675 16.8891 5.5025C18.2964 6.8375 19 8.63 19 10.88C19 12.38 18.4203 14.0113 17.2609 15.7738C16.1016 17.5363 14.3479 19.445 12 21.5Z"
        fill="#1162FF"
      />
    </svg>
  ),
};
